import { createI18n } from 'vue-i18n'
import mZhLocale from './lang/zh.js'
import mEnLocale from './lang/en.js'
import store from '@/store/index.js'

const messages = {
  en: {
    msg: {
      ...mEnLocale
    }
  },
  zh: {
    msg: {
      ...mZhLocale
    }
  }
}

const i18n = createI18n({
  legacy: false,
  globalInjection: true, // 全局注册$t方法
  locale: getLanguage(),
  fallbackLocale: 'zh',
  messages
})
function getLanguage() {
  return (store && store.getters && store.getters.language) || 'zh'
}

export default i18n
